
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/toolkits/lessons/[slug]",
      function () {
        return require("private-next-pages/toolkits/lessons/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/toolkits/lessons/[slug]"])
      });
    }
  